export { default as DocumentationRequestEmailEditViewStore } from './DocumentationRequestEmailEditViewStore';